<template>
  <div>
    <sc-panel-navigator @done="++clock" :search-mode="true" :auto-close-menu="true" :initial-drawer-open="!$route.params.serviceId">
      <el-card>
        <div
            slot="header"
            class="clearfix">
          <el-row type="flex" style="align-items: center;justify-content: space-between">
            <span style="float:left">Services</span>

            <el-button
                style="float:right"
                @click="loadservise('new')"
                size="large">
              <fa
                  icon="plus"
                  fixed-width></fa>
              <fa
                  icon="cubes"
                  fixed-width
                  size="lg"></fa>
            </el-button>
          </el-row>
          <el-row style="border-top:1px white solid;padding-top: .4em;margin-top: .4em ">
            <el-col :md="14">
              <el-input placeholder="...service name" clearable v-model="search"></el-input>
            </el-col>
            <el-col :md="6">
              <el-input placeholder="year" clearable v-model="wYear"></el-input>
            </el-col>
            <el-col :md="4">
              <el-button title="Display unpublished" @click="unpublished=!unpublished"
                         :type="unpublished?'warning':'text'"><span
                  class="material-icons">
unpublished
</span></el-button>
            </el-col>
          </el-row>

        </div>
        <div>
          <s-table
              :key="clock"
              v-if="loaded"
              :simpleLazyLoader="true"
              :colDefinitions="colTripDefinitions"
              modx-processor="tripservice/getlist"
              :r-query="{ search:search ,_all:!(unpublished||false),year:wYear,limit:0,}"
              :cellClassFactory="scp=>!!scp.row.unpublished_at?'disabled_row':null"
              @cell-clicked="loadservise"
              ref="serviseList"></s-table>
        </div>
      </el-card>
    </sc-panel-navigator>
  </div>
</template>


<script>
import {mapActions, mapGetters} from "vuex";
import _ from "lodash";
import * as dateHelper from "date-fns";
import * as api from "~/api/resource";

import printHtml from "~/mixins/printHtml";

export default {
  mixins: [printHtml],
  data() {

    return {
      clock: 0,
      printData: null,
      printReady: false,
      loaded: false,
      timelineView: false,
      page: 1,
      searchall: null,

      cols: {},
      dateFormat: "DD/MM/YY",
    };
  },
  methods: {
    updateTable(msg) {
      _log_("hell.UPDATE..", msg);
      this.$refs.serviseList.updateOrAppendRow(msg);
    },
    async loadservise(selector) {
      _log_("hell...", selector);
      const id = selector.row ? selector.row.id : selector;
      if (this.$route.query.copy_maps) {
        const data = await api.fetchProcessor('tripspointsmap/orderupdate', {
          do: 'copy',
          from: this.$route.query.copy_maps,
          to: id
        })
      }
      this.routeGo({
        name: "service_form",
        params: {serviceId: id},
        query: {copy_maps: null}
      });
    },
  },
  async mounted() {

    this.navLeftIcon = 'search'
    // this.wYear = (new Date()).getFullYear()
    this.loaded = true;
    // _log_("the rs///", this.rooms);
  },
  computed: {
    unpublished: {
      get() {
        const val = this.$route.query.unpublished ? this.$route.query.unpublished : false
        if (val === 'false') return false
        if (val === 'true') return true
        return val
      },
      set(v) {
        this.routeGo({query: {unpublished: v}})
      }
    },
    wYear: {
      get() {
        return this.$route.query.wYear ? this.$route.query.wYear : null
      },
      set(v) {
        this.routeGo({query: {wYear: v}})
      }
    },
    search: {
      get() {
        return this.$route.query.search ? this.$route.query.search : null
      },
      set(v) {
        this.routeGo({query: {search: v}})
      }
    },
    colTripDefinitions() {
      var rw = "580px",
          vm = this;
      if (window.innerWidth < 500) rw = "180px";
      if (window.innerWidth < 700) rw = "280px";
      if (window.innerWidth < 1000) rw = "380px";
      return [
        {prop: "title", width: "", label: "service"},
        {prop: "year", width: "", label: "Date",},
      ];
    },
  },
};
</script>

<style>
.search.x-row {
  align-items: flex-start;
}

.has-more {
  color: red;
  font-weight: 700;
}
</style>
